<template>
  <div class="wind-farm-main-container">
    <Tool
      @mapToolClick="handleToolClick"
      @newWindFarm="handleNewWindFarm"
      @importFile="handleImportFile"
      @seachClick="handleSearchClick"
      :UIStatus="toolUIStatus"
    />

    <leaflet-map
      ref="l"
      v-model="mapData"
      :toolbar="toolbar"
      :toolbarStatus="toolbarStatus"
      v-on:update:toolbarStatus="handleTriggerTools"
      :layers="layers"
      @create="createEleFn"
      :getStyle="getStyle"
      :drawOptions="drawOptions"
      @click="handleElementClick"
      @edit="handleMapInput"
    />

    <transition v-if="isLogin" name="el-fade-in-linear">
      <router-view name="content" :key="someUniqueKey"/>
    </transition>

    <PointDetail
      fromProjectList
      v-if="isShowPointDetail"
      :itemConfig.sync="activePointItem"
      @add="creatPointItem"

    />

<!--    <FaceDetail-->
<!--      fromProjectList-->
<!--      ref="face"-->
<!--      @del="handleDelFaceItemClick"-->
<!--      @createItem="saveCreateItemRect"-->
<!--      @noSaveCreateItem="handleToolClick"-->
<!--      v-if="isShowFaceDetail"-->
<!--      :itemConfig.sync="activeFaceItem"-->
<!--      @updateImg="updateMapItemsIMG"-->
<!--    >-->
<!--    </FaceDetail>-->

    <Location-dialog
      v-if="isSearchDialogShow"
      :visible="isSearchDialogShow"
      @addressSearch="handleAddressSearch"
      @createArea="handleCreateArea"
      @latAndLon="handleCreatePoint"
      :before-close="handleBeforeClose"
    />

    <modal
      title="创建风场"
      :visible.sync="showWindFarmCreateDialog"
      @close="createDialogClose"
    >
      <div class="inner-wrapper">
        <input
          type="text"
          v-model="createForm.windfarmName"
          class="stand-input"
          placeholder="请输入风场名称"
        />
        <div class="my-btn-warpper">
          <ct-button type="primary" :btnClick="handleCreateWindFarmClick"
            >创建</ct-button
          >
        </div>
      </div>
    </modal>

    <modal
      title="导入风场"
      width="500px"
      :visible.sync="showImportWindFarmDialog"
      @close="importDialogClose"
    >
      <div class="inner-wrapper">
        <el-form
          ref="form"
          :rules="uploadrules"
          :model="uploadForm"
          label-width="120px"
        >
          <el-form-item label="风场/风机文件" prop="uploadFileName">
            <el-upload
              class="upload-demo"
              ref="upload"
              :with-credentials="true"
              :auto-upload="false"
              :action="action"
              :data="extraData"
              :on-change="handleUploadChange"
              :on-success="uploadSuccessCb"
              :on-error="uploadErrorCb"
              :file-list="fileList"
              :show-file-list="false"
            >
              <div class="click-area">
                <div class="file-name">{{ uploadForm.uploadFileName }}</div>
                <el-button type="text">上传</el-button>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="风场名称" prop="windfarmName">
            <input
              type="text"
              v-model="uploadForm.windfarmName"
              class="stand-input"
              placeholder="请输入风场名称"
            />
          </el-form-item>
        </el-form>

        <div class="my-btn-warpper">
          <ct-button :btnClick="downloadTemplate">模板下载</ct-button>
          <div class="bar"></div>
          <ct-button :btnClick="handleTriImport" type="primary"
            >风场导入</ct-button
          >
        </div>
      </div>
    </modal>

    <modal
      :title="'创建'+createItemTitle"
      width="500px"
      :visible.sync="createItemDialog"
      @close="noSaveCreateItem"
    >
      <div class="inner-wrapper">
        <el-form
          ref="form1"
          :rules="createItemRules"
          :model="createItemForm"
          label-width="120px"
        >
          <el-form-item :label="createItemTitle+'名称'" prop="itemName">
            <input
              type="text"
              v-model="createItemForm.itemName"
              class="stand-input"
              placeholder="请输入名称"
            />
          </el-form-item>
        </el-form>
        <div class="my-btn-warpper">
          <ct-button type="primary" :btnClick="saveCreateItem">创建</ct-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Big from 'big.js';
import { getToken } from '@/utils';
import Tool from './tools';
import loadingMask from '@/components/loading-mask';
import PointDetail from './project-detail/components/point-item';

import {
  parseMapDataToGeoInfo,
  calcAreaByData,
  toFixed,
  calcAverage,
  findDeepId,
  isObject,
  findDeepByAttr,
  eventBus
} from './utils';
import { mapGetters, mapState } from 'vuex';
import flattenDepth from 'lodash/flattenDepth';
import cloneDeep from 'lodash/cloneDeep';
import { FACEITEMAREALIMIT, WINDFARMAREALIMIT } from './utils/constant';

const COLORS = [
  '#91ca8c',
  '#ffaf51',
  '#ffee51',
  '#8c6ac4',
  '#715c87',
  '#e69d87',
  '#8dc1a9',
  '#ea7e53',
  '#eedd78',
  '#73a373',
  '#73b9bc'
];

export default {
  components: {
    Tool,
    PointDetail
  },
  data() {
    return {
      someUniqueKey:0,
      isSearchDialogShow: false,
      activeFaceItem: null,
      activePointItem: null,
      currentFaceItem: null,
      isShowPointDetail: false,
      isShowFaceDetail: false,
      uploadrules: {
        uploadFileName: [
          { required: true, message: '请上传风场/风机文件', trigger: 'change' }
        ],
        windfarmName: [
          { required: true, message: '请填写风场名称', trigger: 'change' },
          {
            required: true,
            message: '风场名称不超过30个字符',
            trigger: 'change',
            max: 30
          }
        ]
      },
      fileList: [],
      uploadForm: {
        windfarmName: '',
        uploadFileName: ''
      },
      showImportWindFarmDialog: false,
      showWindFarmCreateDialog: false,
      action: `${process.env.VUE_APP_API_HOST}/windfarm/windfarm/uploadWindFarmPointFile`,
      toolbar: {
        drawCircleMarker: false,
        drawPolyline: false,
        drawRectangle: false,
        drawPolygon: false,
        editMode: false,
        removalMode: false,
        dragMode: false
      },
      createForm: {
        windfarmName: '',
        geometryInfo: ''
      },
      // 地图编辑按钮状态控制
      layers: [],
      currentEles: {
        polygons: [],
        points: []
      },
      file: null,
      createItemDialog: false,
      createItemTitle: null,
      createItemForm: {
        itemName: '未命名',
        itemType: null
      },
      createItemOtherParams: null,
      createItemRules: {
        itemName: [
          { required: true, message: '请填写名称', trigger: 'change' }
        ]
      },
      noIdPointItem:{
        datasetCode: '',
        datasetHeight: ''
      }
    };
  },
  beforeDestroy() {
    this.$store.commit('WindFarm/CLEAN_MAP');
    this.$bus.$off('getMapInstance', this.getMapInstance);
    this.$bus.$off('clearUnloginData', this.clearMapData);
    eventBus.$off('getMapInstance', this.getMapInstance);
    this.$bus.$off('clearDetailModal', this.clearDetailModal);
    this.$bus.$off('creatPointItem',this.creatPointItem);
    this.$bus.$off('setNoIdPointItem',this.setNoIdPointItem);
    this.$bus.$off('saveCreateItemRect',this.saveCreateItemRect);
    this.$bus.$off('handleToolClick',this.handleToolClick);

  },
  created() {
    this.$store.dispatch('WindFarm/getDataSet');
    this.$bus.$on('getMapInstance', this.getMapInstance);
    this.$bus.$on('clearUnloginData', this.clearMapData);
    eventBus.$on('getMapInstance', this.getMapInstance);
    this.$bus.$on('creatPointItem',this.creatPointItem);

    this.$bus.$on('clearDetailModal', this.clearDetailModal);
    this.$bus.$on('setNoIdPointItem',this.setNoIdPointItem);
    this.$bus.$on('saveCreateItemRect',this.saveCreateItemRect);
    this.$bus.$on('handleToolClick',this.handleToolClick);
  },
  computed: {
    ...mapGetters(['isLogin']),
    ...mapGetters('WindFarm', [
      'toolUIStatus',
      'drawOptions',
      'windFarmIsEdit',
      'windfarmWireList'
    ]),
    ...mapState('WindFarm', ['toolbarStatus']),
    mapData: {
      get() {
        return this.$store.state.WindFarm.mapData;
      },
      set(val) {
        this.$store.state.WindFarm.mapData = { ...val };
      }
    },
    extraData() {
      return {
        apiKey: getToken(),
        projectId: this.$route.query.projectId,
        windfarmName: this.uploadForm.windfarmName
      };
    }
  },
  watch: {
    $route: {
      handler() {
        this.isShowPointDetail = false;
        this.isShowFaceDetail = false;
      }
    },
    deep: true
  },
  methods: {
    clearMapData() {
      this.currentEles = {
        polygons: [],
        points: []
      };
    },
    handleSearchClick() {
      this.isSearchDialogShow = true;
    },
    handleAddressSearch(payload) {
      const { name, address } = payload;
      if (this.$route.name === 'project-list') {
        const obj = {
          type: 'Point',
          coordinates: [address.lng, address.lat]
        };
        const str = JSON.stringify(obj);

        const params = {
          itemName: name,
          itemType: '1',
          geometryInfo: str,
          projectId: '0',
          data: address
        };
        this.createItems(params);
      } else {
        const { address = {} } = payload;
        this.createPointItem(address, true);
        this.$bus.$emit('getMapInstance', instance => {
          instance.map.setView(
                  {
                    lat: address.lat,
                    lng: address.lng
                  },
                  instance.map.getZoom()
          );
        });
      }
      this.handleBeforeClose();
    },

    async queryBoundaryByregionId(id, transe = false) {
      return this.$fetch('/windfarm/project/getRegionBoundary', {
        showError: true,
        params: {
          // 拿默认的
          regionId: id
        }
      }).then(res => {
        let id = this.createRandomId();
        const { data = {} } = res || [];
        const { regionBoundary = { coordinates: '' } } = data;
        let result = JSON.parse(regionBoundary).coordinates || [];
        if (!transe) {
          return result;
        } else {
          const fuzhi = cloneDeep(result);
          getMap(fuzhi, id);
          return { _polyline: fuzhi, id, regionBoundary };
        }
      });

      function getMap(array, id) {
        if (!array.length) return array;

        if (Array.isArray(array) && typeof array[0] === 'number') {
          array[0] = {
            id,
            lat: array[1],
            lng: array[0]
          };

          array.length = 1;
          return 'change';
          // Reflect.deleteProperty(array, '1');
        } else {
          for (let i = 0; i < array.length; i++) {
            let flag = getMap(array[i], id);

            if (flag === 'change') {
              array[i] = array[i][0];
            }
          }
        }
      }
    },

    async handleCreateArea(payload) {
      if (this.$route.name === 'project-list') {
        const { name, code } = payload;
        const {
          _polyline,
          id,
          regionBoundary
        } = await this.queryBoundaryByregionId(code, true);

        const polyline = flattenDepth(_polyline, 4);

        // const geometryInfo = parseMapDataToGeoInfo(polyline, 'Polygon', false);

        const params = {
          projectId: '0',
          itemName: name,
          adcode: code,
          data: _polyline,
          extra: polyline,
          geometryInfo: regionBoundary,
          itemType: '4',
          area: calcAreaByData(polyline, false)
        };

        this.createItems(params, id);
      } else {
        const { name, code } = payload;
        const {
          _polyline,
          regionBoundary
        } = await this.queryBoundaryByregionId(code, true);
        // const polyline = flattenDepth(_polyline, 4);
        this.createPolygonItem(_polyline, 4, code, {
          geometryInfo: regionBoundary,
          name: name,
          needTrans: false,
          _polyline,
          setView: true
        });
      }
      this.handleBeforeClose();
    },
    handleCreatePoint(data) {
      if (this.$route.name === 'project-list') {
        const obj = {
          type: 'Point',
          coordinates: [data.lng, data.lat]
        };
        const str = JSON.stringify(obj);

        const params = {
          itemName: '未命名',
          itemType: '1',
          geometryInfo: str,
          projectId: '0',
          data: data
        };
        this.createItems(params);
      } else {
        this.createPointItem(data, true);
        this.$bus.$emit('getMapInstance', instance => {
          instance.map.setView(
                  {
                    lat: data.lat,
                    lng: data.lng
                  },
                  instance.map.getZoom()
          );
        });
      }
      this.handleBeforeClose();
    },

    handleBeforeClose() {
      this.isSearchDialogShow = false;
    },
    updateMapItemsIMG(payload) {
      const { id, url } = payload;

      const item = this.currentEles.polygons.find(i => i.itemId === id);
      item.url = url;
      item.tupuUrl = url;

      this.updateMap();
    },
    refreshDatas() {
      this.someUniqueKey = Date.now();
      this.isShowPointDetail = false;
    },
    //创建点
    creatPointItem(params){
      this.postCreateItemApi(params)
              .then(res => {
                const { data = {} } = res;
                const { projectItem = {} } = data;

                this.$store.commit('WindFarm/default_MAP_POINT');
                this.handleToolClick('point', false);
                this.$bus.$emit('updateWindFarmAndItems', {
                  data: { ...projectItem,...this.noIdPointItem },
                  type: 'point',
                  setView: true
                });
                const _this = this;
                setTimeout(function(){
                  _this.isShowPointDetail = false;
                },1000);

              })
              .catch(() => {
                this.$store.commit('WindFarm/default_MAP_POINT');
              });
    },
    handleDelFaceItemClick() {},
    handleMapInput(e) {
      console.log(e);
    },
    getMapInstance(cb) {
      cb(this.$refs.l);
    },
    handleElementClick(e) {
      let { type, data, map } = e;

      if (this.$route.name === 'project-list') {
        let _type, id;
        if (e.type === 'markers') {
          _type = '1';
          id = e.data.id || '';
        }

        if (e.type === 'polygons') {
          // id = e.data[0].id || '';
          id = findDeepId(e.data);
          _type = '2';
        }
        this.showItemById(id, _type);
        return;
      }

      if (type === 'markers') {
        data = data || {};

        const { type } = data;
        if (type === 'fengji') {
          this.fengjiClick(data, map);
        }else if (type === 'gantaPoint') {
          this.gantaClick(data, map);
        }else if (type === 'res-point') {
          this.$bus.$emit('res-point-click', data);
        }else{
          //临时点
          this.createPointItem(data);
        }
      }

      if (type === 'polygons') {
        const { type } = data[0];

        if (type === 'faceItems' || type === 'faceItems_xingzheng') {
          return this.$bus.$emit('res-face-click', data);
        }

        if (type === 'windscope') {
          return this.$bus.$emit('wind-scope-click', data);
        }

        this.$bus.$emit('res-face-click', data);
      }

      if (type === 'polylines') {
        const myType = findDeepByAttr(data, 'type');

        if (myType === 'roadlist') {
          this.$bus.$emit('road-line-click', data);
        } else if (myType === 'wirelist') {
          this.$bus.$emit('wire-line-click', data);
        }
      }
    },
    downloadTemplate() {
      window.open(
        `${process.env.VUE_APP_API_HOST}/windfarm/project/getTemplateFile?fileName=windfarm.xlsx`,
        '_parent'
      );
    },
    fengjiClick(data, map) {
      this.$bus.$emit('clickFengji', data, map);
    },
    gantaClick(data, map) {
      this.$bus.$emit('clickGanta', data, map);
    },
    handleUploadChange(file, fileList) {
      if (!fileList.length) {
        this.file = null;
        this.uploadForm.uploadFileName = '';
      } else {
        this.file = file;
        this.uploadForm.uploadFileName = file?.name;
        this.fileList = [file];
      }

      // this.fileList = fileList;
      // this.file = null;
      // this.uploadForm.uploadFileName = '';
    },
    handleTriImport() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const formData = new FormData();
          formData.append('file', this.file?.raw);
          formData.append('apiKey', getToken());

          this.$fetch({
            method: 'POST',
            url: '/windfarm/windfarm/uploadFileCheck',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            noJudge: true
          }).then(res => {
            const { code, message } = res.data;

            if (code == 0) {
              this.aswitch = loadingMask({ mask: true });

              this.$refs.upload.submit();
            }

            if (code == 2) {
              this.$confirm(message, '提醒', {
                confirmButtonText: '继续上传',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnClickModal: false
              }).then(() => {
                this.aswitch = loadingMask({ mask: true });
                this.$refs.upload.submit();
              });
            }

            if (code == 1) {
              return this.$message.error(message);
            }
          });
        }
      });
    },
    uploadErrorCb() {
      this.file = null;
      this.showImportWindFarmDialog = false;
      this.$refs.form.resetFields();

      this.aswitch && this.aswitch.close();
    },
    uploadSuccessCb(res) {
      const { code, message, data } = res;
      this.aswitch && this.aswitch.close();
      this.fileList = [];
      this.uploadForm.uploadFileName = '';
      this.uploadForm.windfarmName = '';

      this.$refs.form.resetFields();
      this.file = '';

      this.$refs.upload.clearFiles();
      if (code === 0) {
        const { windfarm = {} } = data;

        this.showImportWindFarmDialog = false;
        this.$message({
          message: message,
          type: 'success'
        });
        this.uploadForm.uploadFileName = '';

        // 成功后做的事情
        this.$bus.$emit('updateWindFarmAndItems', {
          type: 'windFarm',
          data: windfarm
        });
      } else {
        this.$message({
          message: message,
          type: 'error'
        });
      }
    },
    layerChange(layers) {
      this.layers = layers;
    },
    handleImportFile() {
      if (this.$route.name === 'project-list') {
        return this.$message.warning('未进入项目暂不可用');
      }

      this.showImportWindFarmDialog = true;
    },
    clearDetailModal(){
      if(this.isShowPointDetail){
        this.handleToolClick('point', false);
        this.activePointItem = null;
        this.isShowPointDetail = null;
      }
      if(this.isShowFaceDetail){
        if (this.createItemForm.itemType == 2) {
          this.handleToolClick('rect', false);
          this.$store.commit('WindFarm/POP_MAPDATA_RECT');
        }

        if (this.createItemForm.itemType == 3) {
          this.handleToolClick('polygon', false);
          this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
        }
        this.activeFaceItem = null;
        this.isShowFaceDetail = null;
      }
    },
    handleToolClick(type, value) {
      if (type === 'point') {
        let status;

        if (value !== undefined) {
          status = !value;
        } else {
          status = this.toolUIStatus['marker'];
        }

        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
          key: 'marker',
          value: !status
        });

        this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
          key: 'drawMarker',
          value: !status
        });
      }

      if (type === 'polygon') {
        let status;

        if (value !== undefined) {
          status = !value;
        } else {
          status = this.toolUIStatus['polygon'];
        }

        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
          key: 'polygon',
          value: !status
        });

        this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
          key: 'drawPolygon',
          value: !status
        });
      }

      if (type === 'rect') {
        let status;

        if (value !== undefined) {
          status = !value;
        } else {
          status = this.toolUIStatus['rectangle'];
        }

        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
          key: 'rectangle',
          value: !status
        });

        this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
          key: 'drawRectangle',
          value: !status
        });
      }
    },
    handleNewWindFarm(value) {
      if (this.$route.name === 'project-list')
        return this.$message.warning('未进入项目暂不可用');

      let status;

      if (value !== undefined) {
        status = !value;
      } else {
        status = this.toolUIStatus['newFarm'];
      }

      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

      this.$store.commit('WindFarm/SET_DRAWCOLOR', 'orange');

      this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
        key: 'newFarm',
        value: !status
      });

      this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
        key: 'drawPolygon',
        value: !status
      });
    },

    createRandomId() {
      return Math.ceil(Math.random() * 1000000);
    },

    createItems(params, getId = '') {
      let id = getId;
      if (!id) {
        id = this.createRandomId();
      }

      const {
        itemType = '',
        data,
        itemName,
        area,
        geometryInfo,
        adcode,
        extra
      } = params;

      if (itemType == '1') {
        this.currentEles.points.push({
          data,
          itemName,
          lon: data.lng,
          lat: data.lat,
          id,
          itemType,
          itemId: id,
          datasetCode: '',
          datasetHeight: ''
        });
      } else if (itemType == '4') {
        this.currentEles.polygons.push({
          data: data,
          area,
          itemName,
          itemType,
          id,
          itemId: id,
          url: '',
          extra,
          code: adcode,
          geometryInfo,
          datasetCode: '',
          datasetHeight: '',
          elementCode: 'wspd',
          legendRange: '2',
          tupuUrl: ''
        });
      } else {
        this.currentEles.polygons.push({
          data: data.map(i => ({ id, ...i })),
          area,
          itemName,
          itemType,
          id,
          itemId: id,
          url: '',
          code: null,
          geometryInfo,
          datasetCode: '',
          datasetHeight: '',
          elementCode: 'wspd',
          legendRange: '2',
          tupuUrl: ''
        });
      }

      this.$nextTick(() => {
        this.updateMap(() => {
          this.showItemById(id, itemType, true);
        });
      });
    },

    showItemById(id, type, setView = false) {
      if (type == '1') {
        const pointsList = this.currentEles.points || [];

        const item = pointsList.find(i => i.id == id);
        const data = item.data;

        if (setView) {
          this.$refs.l.map.setView({
            lat: data.lat,
            lon: data.lng
          });
        }

        const { data: aData } = item;

        const { lat, lng } = aData;

        this.activePointItem = item;
        this.pointLocation = {
          lat: toFixed(lat, 6),
          lon: toFixed(lng, 6)
        };

        this.isShowFaceDetail = false;

        this.isShowPointDetail = true;
      } else {
        const polys = this.currentEles.polygons || [];

        const item = polys.find(i => i.id == id);

        let data = item.data;
        if (type == '4') {
          data = item.extra;
        }

        let aver1 = data.map(i => i.lat);
        let aver2 = data.map(i => i.lng);

        const loc = {
          lat: calcAverage(aver1),
          lng: calcAverage(aver2)
        };

        if (setView) {
          this.$refs.l.map.setView(loc);
        }

        this.activeFaceItem = item;

        this.isShowPointDetail = false;
        this.isShowFaceDetail = true;
      }
    },

    updateMap(cb) {
      this.$store.commit('WindFarm/CLEAN_MAP');

      const markers = this.currentEles.points.map(i => {
        return {
          ...i.data,
          id: i.id,
          iconSize: [25, 40],
          iconAnchor: [13, 54],
          icon: require('@/asset/windfarm/marker-icon.png')
          // icon: pointIcon
        };
      });

      const polygons = this.currentEles.polygons
        .filter(i => i.itemType != '4')
        .map(i => {
          return [...i.data];
        });

      const xingzheng = this.currentEles.polygons
        .filter(i => i.itemType == '4')
        .map(i => {
          return [...i.data];
        });

      const imgs = this.currentEles.polygons
        .filter(i => i.url)
        .map(i => {
          let maxLat = -1000;
          let maxLng = -1000;
          let minLat = 1000;
          let minLng = 1000;

          const handleData =
            i.itemType == '4' ? flattenDepth(i.data, 4) : i.data;

          handleData.forEach(item => {
            const { lat, lng } = item;

            if (maxLat < lat) {
              maxLat = lat;
            }

            if (minLat > lat) {
              minLat = lat;
            }

            if (maxLng < lng) {
              maxLng = lng;
            }

            if (minLng > lng) {
              minLng = lng;
            }
          });

          const data = [
            {
              lat: maxLat,
              lng: minLng
            },
            {
              lat: maxLat,
              lng: maxLng
            },
            {
              lat: minLat,
              lng: maxLng
            },
            {
              lat: minLat,
              lng: minLng
            }
          ];

          return {
            latlngs: data,
            url: i.url
          };
        });

      this.$store.commit('WindFarm/SET_RAW_POLYGONS_ARR', {
        type: 'project-list-poly_xingzheng',
        data: xingzheng
      });

      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'project-list-poly',
        data: polygons
      });

      this.$store.commit('WindFarm/SET_RAW_MARKERS', {
        type: 'project-list-point',
        data: markers
      });

      this.$store.commit('WindFarm/SET_IMAGE', imgs);

      this.$nextTick(() => {
        cb && cb();
      });
    },

    createInProjectList(e) {
      const { type, data } = e;

      if (type === 'markers') {
        const obj = {
          type: 'Point',
          coordinates: [data.lng, data.lat]
        };
        const str = JSON.stringify(obj);
        const params = {
          itemName: '未命名',
          itemType: '1',
          geometryInfo: str,
          data,
          projectId: '0'
        };

        this.createItems(params);
      }

      if (type === 'polygons') {
        const area = calcAreaByData(data, true);
        if (area < 100) {
          this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
          this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

          return this.$message.warning('面积不能小于100平方公里');
        }

        if (area > FACEITEMAREALIMIT) {
          this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
          this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

          return this.$message.warning('面积不能大于100万平方公里');
        }

        const str = parseMapDataToGeoInfo(data, 'Polygon', true);
        const params = {
          itemName: '未命名',
          itemType: '3',
          geometryInfo: str,
          data,
          projectId: '0',
          area: area
        };
        this.createItems(params);
      }

      if (type === 'rectangles') {
        const area = calcAreaByData(data, true);

        if (area < 0.1) {
          this.$store.commit('WindFarm/POP_MAPDATA_RECT');
          this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

          return this.$message.warning('面积不能小于100平方公里');
        }

        if (area > FACEITEMAREALIMIT) {
          this.$store.commit('WindFarm/POP_MAPDATA_RECT');
          this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

          return this.$message.warning('面积不能大于100万平方公里');
        }

        const str = parseMapDataToGeoInfo(data, 'Polygon', true);

        const params = {
          itemName: '未命名',
          itemType: '2',
          geometryInfo: str,
          data,
          projectId: '0',
          area: area
        };
        this.createItems(params);
      }

      // 清除按钮状态
      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
    },

    createEleFn(e) {
      const { type, data } = e;

      if (this.$route.name === 'project-list') {
        this.createInProjectList(e);
        return;
      }

      const newWindFarmstatus = this.toolUIStatus['newFarm'];
      const pointItemStatus = this.toolUIStatus['marker'];
      const polygonItemStatus = this.toolUIStatus['polygon'];
      const rectItemStatus = this.toolUIStatus['rectangle'];
      const shengyazhanAdd = this.toolUIStatus['shengyazhanAdd'];
      const limitAdd = this.toolUIStatus['limitAdd'];
      const entrance = this.toolUIStatus['entrance'];
      const keyPoint = this.toolUIStatus['keyPoint'];
      const lxLimitAdd = this.toolUIStatus['lxLimitAdd'];
      const fengjiPoint = this.toolUIStatus['fengji'];
      // 走创建风场逻辑
      if (newWindFarmstatus && type === 'polygons') {
        // 弹窗
        this.createWindFarmFn(data);
      }

      if (pointItemStatus && type === 'markers') {
        this.createPointItem(data);
      }

      if (polygonItemStatus && type === 'polygons') {
        this.createPolygonItem(data, 3);
      }

      if (rectItemStatus && type === 'rectangles') {
        this.createPolygonItem(data, 2);
      }

      if (shengyazhanAdd && type === 'markers') {
        this.$bus.$emit('createShengyazhan', data);
      }

      if (limitAdd && type === 'polygons') {
        this.$bus.$emit('createLimitAdd', data);
      }

      if (entrance && type === 'markers') {
        this.$bus.$emit('createEntrancePoint', data);
      }

      if (keyPoint && type === 'markers') {
        this.$bus.$emit('createKeypoint', data);
      }

      if (lxLimitAdd && type === 'polygons') {
        this.$bus.$emit('createLXLimitAdd', data);
      }

      if (fengjiPoint && type === 'markers') {
        this.$bus.$emit('createfengji', data);
      }

      //console.log(type);
    },

    createPolygonItem(
      data,
      itemType,
      adcode = '',
      extra = {
        name: '',
        geometryInfo: '',
        area: '',
        setView: false
      }
    ) {
      let area = 0;

      if (data !== null) {
        if(itemType == 4){
           for(let i=0;i<data.length;i++){
             let areaItem = calcAreaByData(data[i][0], true);
             area = new Big(area).plus(new Big(areaItem));
           }
           area = toFixed(area.toString(),4);
        }else{
          area = calcAreaByData(data, true);
        }

        if (area < 10) {
          if (itemType == 3) {
            this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
          }
          if (itemType == 2) {
            this.$store.commit('WindFarm/POP_MAPDATA_RECT');
          }
          this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
          return this.$message.warning('面积不能小于10平方公里');
        }

        if (area > FACEITEMAREALIMIT) {
          if (itemType == 3) {
            this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
          }
          if (itemType == 2) {
            this.$store.commit('WindFarm/POP_MAPDATA_RECT');
          }
          this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
          return this.$message.warning('面积不能大于' + FACEITEMAREALIMIT/10000 + '万平方公里');
        }
      }

      const params = {
        itemType: itemType, // 多边形
        projectId: this.$route.query.projectId,
        itemName: '未命名',
        area: area,
        adcode: adcode
      };

      if (itemType == 4) {
        params.itemName = extra.name;
        params.geometryInfo = extra.geometryInfo;
      } else {
        params.geometryInfo = parseMapDataToGeoInfo(
          data,
          'Polygon',
          itemType != 4
        );
      }

      this.createTiemTitelDialog(params,{extra});

    },
    createPointItem(data, setView = false) {
      this.$store.commit('WindFarm/default_MAP_POINT');
      this.$bus.$emit('defaultPoint',{
        ...data,
        itemId: 0
      });
      this.$store.commit('WindFarm/SET_MARKER',{
        type:'markers',
        data:{
        ...data,
          id: 0,
          iconSize: [25, 40],
          iconAnchor: [13, 54],
          icon: require('@/asset/windfarm/marker-icon.png')
        }
      });
      this.$bus.$emit('resetActiveItem');
      console.log(setView);
      this.activePointItem = {
        datasetCode: '',
        datasetHeight: '',
        itemId: 0,
        lat:data.lat,
        lon: data.lng,
        ...this.noIdPointItem
      };
      this.isShowFaceDetail = false;
      // this.isShowPointDetail = true;
      this.$bus.$emit('showPoint',this.activePointItem);

    },
    setNoIdPointItem(item){
      this.noIdPointItem = {...item}
    },
    createWindFarmFn(data) {
      const maxLats = Math.max(...data.map(i => i.lat));
      const minLats = Math.min(...data.map(i => i.lat));
      const minLngs = Math.min(...data.map(i => i.lng));
      const maxLngs = Math.max(...data.map(i => i.lng));

      if (maxLats > 90 || minLats < -90) {
        this.$message.warning('风场范围的纬度应在-90°至90°之间');
        this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        return;
      }

      if (maxLngs > 180 || minLngs < -180) {
        this.$message.warning('风场范围的经度应在-180°至180°之间');
        this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        return;
      }

      const area = calcAreaByData(data, true);

      if (area > WINDFARMAREALIMIT) {
        this.$message.warning('面积不能大于5000平方公里');
        this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        return;
      }

      if (area < 0.1) {
        this.$message.warning('面积不能小于0.1平方公里');
        this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
        this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
        return;
      }

      const newData = data.concat([data[0]]);
      const str = parseMapDataToGeoInfo(newData, 'Polygon');

      this.createForm.geometryInfo = str;
      this.showWindFarmCreateDialog = true;
    },
    hideCreateItemDialog(){
      this.createItemDialog = false;
      this.createItemForm =  {
        itemName: '未命名',
        itemType: null
      };
      this.createItemOtherParams = null;
      this.queryWindfarmAndItemList(() => {
        this.requestItemsElementMap('point');
      });
    },
    noSaveCreateItem(){
      if(this.createItemForm.itemType == 1){
        this.$store.commit('WindFarm/POP_MAP_POINT');
      }
      if (this.createItemForm.itemType == 2) {
        this.$store.commit('WindFarm/POP_MAPDATA_RECT');
      }

      if (this.createItemForm.itemType == 3) {
        this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
      }

      this.hideCreateItemDialog();
    },
    createTiemTitelDialog(params,other){
      this.createItemForm = {...params};
      this.createItemOtherParams = {...other}
      if(params.itemType == '1'){
        this.createItemDialog = true;
        if(params.itemType == '1'){
          this.createItemTitle = "点位";
        } else{
          this.createItemTitle = "区域";
        }

      // }else if(params.itemType == '4'){
      //   this.saveCreateItemRect();
      }else{
        this.$bus.$emit('resetActiveItem');
        const itemDetail = {
          ...params,
          itemId: 0
        }
        this.activeFaceItem = {
          ...itemDetail
        };
        // this.isShowFaceDetail = true;
        this.$bus.$emit('defaultPolygon',{
          ...itemDetail
        });
        if (params.itemType == 2) {
          this.handleToolClick('rect', false);
        }

        if (params.itemType == 3) {
          this.handleToolClick('polygon', false);
        }
      }


    },
    saveCreateItem(){
      this.$refs.form1.validate(valid => {
        if (valid) {
          if(this.createItemForm.itemType == '1'){
            this.postCreateItemApi(this.createItemForm)
                    .then(res => {
                      const { data = {} } = res;
                      const { projectItem = {} } = data;

                      this.$store.commit('WindFarm/POP_MAP_POINT');
                      this.handleToolClick('point', false);
                      this.$bus.$emit('updateWindFarmAndItems', {
                        data: projectItem,
                        type: 'point',
                        setView: this.createItemOtherParams.setView
                      });

                      this.hideCreateItemDialog();
                    })
                    .catch(() => {
                      this.$store.commit('WindFarm/POP_MAP_POINT');
                    });
          }else{
            this.postCreateItemApi(this.createItemForm)
                    .then(res => {
                      const { data = {} } = res;
                      const { projectItem = {} } = data;

                      if (this.createItemForm.itemType == 2) {
                        this.$store.commit('WindFarm/POP_MAPDATA_RECT');
                      }

                      if (this.createItemForm.itemType == 3) {
                        this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
                      }

                      this.handleToolClick('point', false);
                      this.$bus.$emit('updateWindFarmAndItems', {
                        data: projectItem,
                        type: 'poly',
                        setView: this.createItemOtherParams.extra.setView || false
                      });

                      this.hideCreateItemDialog();
                    })
                    .catch(() => {
                      if (this.createItemForm.itemType == 2) {
                        this.$store.commit('WindFarm/POP_MAPDATA_RECT');
                      }

                      if (this.createItemForm.itemType == 3) {
                        this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
                      }
                    });
          }
        }
      });

    },
    saveCreateItemRect(datasetCode){
      this.postCreateItemApi(this.createItemForm)
              .then(res => {
                const { data = {} } = res;
                const { projectItem = {} } = data;

                if (this.createItemForm.itemType == 2) {
                  this.$store.commit('WindFarm/POP_MAPDATA_RECT');
                  this.handleToolClick('rect', false);
                }

                if (this.createItemForm.itemType == 3) {
                  this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
                  this.handleToolClick('polygon', false);
                }

                this.$bus.$emit('updateWindFarmAndItems', {
                  data: {
                    ...projectItem,
                    ...datasetCode
                  },
                  type: 'poly',
                  setView: this.createItemOtherParams.extra.setView || false
                });

                this.hideCreateItemDialog();
              })
              .catch(() => {
                if (this.createItemForm.itemType == 2) {
                  this.$store.commit('WindFarm/POP_MAPDATA_RECT');
                }

                if (this.createItemForm.itemType == 3) {
                  this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
                }
              });
    },
    postCreateItemApi(params) {
      return this.$postForm('/windfarm/project/createItem', {
        showSuccess: true,
        showError: true,
        data: {
          ...params
        }
      });
    },
    handleCreateWindFarmClick() {
      if (!this.createForm.windfarmName)
        return this.$message.warning('请输入风场名称');

      this.$postForm('/windfarm/windfarm/createWindfarm', {
        showSuccess: true,
        showError: true,
        data: {
          projectId: this.$route.query.projectId,
          windfarmName: this.createForm.windfarmName,
          geometryInfo: this.createForm.geometryInfo
        }
      })
        .then(res => {
          this.createDialogClose();

          this.$bus.$emit('updateWindFarmAndItems', {
            type: 'windFarm',
            data: res?.data?.windfarm
          });
        })
        .catch(() => {
          this.createDialogClose();
        });
    },
    createDialogClose() {
      this.createForm.windfarmName = '';
      this.createForm.geometryInfo = '';
      this.showWindFarmCreateDialog = false;
      this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
      this.handleNewWindFarm(false);
    },
    importDialogClose() {
      this.uploadForm.windfarmName = '';
      this.uploadForm.uploadFileName = '';
    },
    getStyle(type, data) {
      if (this.windFarmIsEdit && type === 'polygons') {
        const type = findDeepAttr(data) || '';

        if (!type) {
          return { color: 'orange', fillOpacity: 0.2 };
        }
      }

      if (type === 'polygons') {
        const type = findDeepAttr(data) || '';
        // const isClickActive = data && data[0] && data[0].isClickActive;

        if (type === 'windscope') {
          return { color: 'orange', fillOpacity: 0.2 };
        } else if (type === 'deploy-condition') {
          return { color: 'pink', fillOpacity: 0.2 };
        } else if (type === 'faceItems') {
          return { color: '#478beb', fillOpacity: 0 };
        } else if (type === 'lx-result-area') {
          return {
            color: '#73d13d',
            fillOpacity: 0.2
          };
        } else if (type === 'lx-limit-area') {
          return {
            color: 'pink',
            fillOpacity: 0.2
          };
        } else {
          return { color: '#478beb', fillOpacity: 0.2 };
        }
      }

      if (type === 'polylines') {
        const itemType = findDeepAttr(data) || '';

        if (itemType === 'roadlist') {
          return {
            color: '#fff',
            fillOpacity: 0
          };
        }

        if (itemType === 'wirelist') {
          const myIndex = this.windfarmWireList.findIndex(
            wire => wire.wireId === findDeepAttr(data, 'wireId')
          );

          return {
            color: COLORS[myIndex % COLORS.length],
            fillOpacity: 0.2,
            width: '10'
          };
        }
      }

      function findDeepAttr(data, attr = 'type') {
        if (!data) return '';

        if (Array.isArray(data)) {
          return findDeepAttr(data[0], attr);
        } else if (isObject(data)) {
          return data[attr] || '';
        }
      }
    },

    handleTriggerTools() {
      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
    }
  }
};
</script>

<style lang="less" scoped>
.bar {
  display: inline-block;
  width: 10px;
}
.wind-farm-main-container {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.upload-demo {
  height: 28px;
  .click-area {
    .file-name {
      width: 300px;
      height: 28px;
      border-radius: 7px;
      padding-left: 10px;
      text-align: left;
      margin-right: 20px;
      background-color: #fff;
      border: 2px solid #d9e6f3;
    }
    display: flex;
    justify-content: space-between;
  }
}

.inner-wrapper {
  padding: 20px 11px 10px 11px;
  display: flex;
  flex-direction: column;
  // text-align: center;
  // background-color: #fff;
  justify-content: center;
  // background-color: #c8e0f5;
}
.my-input {
  height: 40px;
  background-color: #fff;
  border-radius: 5px;
  padding: 0px 13px;
}
.my-btn-warpper {
  padding-top: 15px;
  text-align: right;
}
</style>

<style lang="less">
.common-first-modal-container {
  position: absolute;
  background: #c8e0f5;
  overflow: auto;
  z-index: 500;
  left: 250px;
  top: 3%;
  border-radius: 8px;
}
.wind-farm-main-container {
  .leaflet-popup-content-wrapper {
    position: relative;
  }
}
</style>
